import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';

export default function AboutPage() {
  const aboutJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'AboutPage',
    name: '关于黄油在线玩',
    description: '黄油在线玩是一个免费黄油游戏在线平台，提供海量黄油游戏免费在线体验。无需下载安装，打开浏览器即可畅玩。',
    url: 'https://huangyouzaxianwan.com/about',
    about: {
      '@type': 'Organization',
      name: '黄油在线玩',
      description: '免费黄油游戏在线平台',
      foundingDate: '2023',
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        email: 'support@huangyouzaxianwan.com',
      },
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '黄油在线玩是否需要下载安装？',
        acceptedAnswer: { '@type': 'Answer', text: '不需要！黄油在线玩平台的所有游戏都支持在线即点即玩，无需下载安装任何客户端或游戏文件。' },
      },
      {
        '@type': 'Question',
        name: '平台支持哪些设备？',
        acceptedAnswer: { '@type': 'Answer', text: '黄油在线玩支持PC端（Windows/Mac/Linux）和手机端（iOS/Android）。' },
      },
      {
        '@type': 'Question',
        name: '游戏是否完全免费？',
        acceptedAnswer: { '@type': 'Answer', text: '是的，平台上所有游戏都可以免费畅玩！' },
      },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">{JSON.stringify(aboutJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-16">
          <div className="bg-background-100">
            <div className="max-w-4xl mx-auto">
              <Breadcrumb
                items={[
                  { label: '首页', path: '/' },
                  { label: '关于我们' },
                ]}
              />
              <div className="px-4 md:px-6 pb-8">
                <h1 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-2">关于我们</h1>
                <p className="text-sm text-foreground-500">了解黄油在线玩的故事与使命</p>
              </div>
            </div>
          </div>

          <section className="max-w-4xl mx-auto px-4 md:px-6 py-10">
            <div className="flex flex-col lg:flex-row gap-8 items-start">
              <div className="flex-1">
                <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-4">品牌故事</h2>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  黄油在线玩成立于2023年，是国内领先的免费黄油游戏在线平台。我们的使命是让每一位游戏爱好者都能轻松便捷地享受黄油游戏的乐趣。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  我们深知传统游戏下载安装的繁琐——等待时间、存储空间、兼容性问题常常让人望而却步。因此，黄油在线玩采用先进的云游戏技术，让玩家无需下载安装，打开浏览器即可畅玩海量黄油游戏。
                </p>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  从最初的几十款游戏，到现在收录超过500款精品黄油游戏，我们始终坚持"免费、便捷、优质"的核心理念。每日更新新游戏，不断优化平台体验，只为给玩家带来最好的黄油在线玩体验。
                </p>
              </div>
              <div className="w-full lg:w-80 flex-shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20office%20with%20warm%20lighting%2C%20creative%20workspace%2C%20team%20collaboration%20atmosphere%2C%20clean%20white%20and%20wood%20aesthetic%2C%20cozy%20modern%20office%20design%2C%20soft%20natural%20light%2C%20plants%20and%20wooden%20furniture&width=600&height=400&seq=about-brand&orientation=landscape"
                  alt="黄油在线玩团队"
                  className="w-full rounded-lg object-cover"
                />
              </div>
            </div>
          </section>

          <section className="w-full bg-background-100 py-12 md:py-14">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-8 text-center">平台数据</h2>
              <div className="grid grid-cols-2 sm:grid-cols-4 gap-6">
                <div className="text-center p-5 bg-background-50 rounded-lg">
                  <p className="text-3xl md:text-4xl font-bold text-primary-500">500+</p>
                  <p className="text-xs text-foreground-500 mt-2">精品黄油游戏</p>
                </div>
                <div className="text-center p-5 bg-background-50 rounded-lg">
                  <p className="text-3xl md:text-4xl font-bold text-accent-500">500万+</p>
                  <p className="text-xs text-foreground-500 mt-2">活跃玩家</p>
                </div>
                <div className="text-center p-5 bg-background-50 rounded-lg">
                  <p className="text-3xl md:text-4xl font-bold text-secondary-600">6个</p>
                  <p className="text-xs text-foreground-500 mt-2">游戏分类</p>
                </div>
                <div className="text-center p-5 bg-background-50 rounded-lg">
                  <p className="text-3xl md:text-4xl font-bold text-primary-500">每日</p>
                  <p className="text-xs text-foreground-500 mt-2">更新新游戏</p>
                </div>
              </div>
            </div>
          </section>

          <section className="max-w-4xl mx-auto px-4 md:px-6 py-10">
            <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-6">玩家口碑</h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="p-5 bg-background-100 rounded-lg">
                <div className="flex items-center gap-1 mb-3 text-primary-500">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  "黄油在线玩真的太方便了，不用下载就能玩各种游戏，上班摸鱼必备！游戏种类也很丰富，每天都有新游戏上线。"
                </p>
                <p className="text-xs text-foreground-400">— 游戏达人小王</p>
              </div>
              <div className="p-5 bg-background-100 rounded-lg">
                <div className="flex items-center gap-1 mb-3 text-primary-500">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  "之前下载游戏总是担心病毒和存储空间，现在直接在黄油在线玩上玩，安全又省心。推荐给身边所有朋友了！"
                </p>
                <p className="text-xs text-foreground-400">— 休闲玩家小李</p>
              </div>
              <div className="p-5 bg-background-100 rounded-lg">
                <div className="flex items-center gap-1 mb-3 text-primary-500">
                  {[1, 2, 3, 4, 5].map((s) => (
                    <i key={s} className="ri-star-fill text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3">
                  "手机端也能流畅玩，通勤路上也能来两把。黄油在线玩的云存档功能也很赞，换设备继续玩，进度不丢失。"
                </p>
                <p className="text-xs text-foreground-400">— 手游爱好者小张</p>
              </div>
            </div>
          </section>

          <section className="w-full bg-background-100 py-12 md:py-14">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900 mb-8 text-center">联系我们</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-10">
                <div className="flex items-start gap-4 p-5 bg-background-50 rounded-lg">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-mail-line text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">电子邮箱</h3>
                    <p className="text-xs text-foreground-500">support@huangyouzaxianwan.com</p>
                    <p className="text-xs text-foreground-400 mt-0.5">工作日24小时内回复</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 bg-background-50 rounded-lg">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 flex-shrink-0">
                    <i className="ri-customer-service-line text-accent-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">在线客服</h3>
                    <p className="text-xs text-foreground-500">工作日 9:00 - 18:00</p>
                    <p className="text-xs text-foreground-400 mt-0.5">即时响应，专业服务</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 bg-background-50 rounded-lg">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 flex-shrink-0">
                    <i className="ri-map-pin-line text-secondary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">公司地址</h3>
                    <p className="text-xs text-foreground-500">中国上海市浦东新区</p>
                    <p className="text-xs text-foreground-400 mt-0.5">科技创新园区</p>
                  </div>
                </div>
                <div className="flex items-start gap-4 p-5 bg-background-50 rounded-lg">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 flex-shrink-0">
                    <i className="ri-qq-line text-primary-600"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-800 mb-1">官方QQ群</h3>
                    <p className="text-xs text-foreground-500">群号：888888888</p>
                    <p className="text-xs text-foreground-400 mt-0.5">加入玩家社区交流</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </>
  );
}